import { UI, Stack } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

interface SubscriptionSolicitationSuccessActionsProps {
  onClose: () => void;
  onFollow: () => void;
  closeButtonText?: string;
  followButtonText?: string;
}

export const SubscriptionSolicitationSuccessActions: React.FC<
  SubscriptionSolicitationSuccessActionsProps
> = ({ onClose, onFollow, closeButtonText = 'VOLTAR', followButtonText = 'ACOMPANHAR' }) => {
  return (
    <Stack
      direction={Utils.Responsive.TabletDesktop({ tablet: 'column', desktop: 'row' })}
      justifyContent="space-between"
      space="inline.xxxs">
      <UI.Button flex={1} variant="secondary" onPress={onClose}>
        {closeButtonText}
      </UI.Button>
      <UI.Button flex={1} variant="primary" onPress={onFollow}>
        {followButtonText}
      </UI.Button>
    </Stack>
  );
};
